// eslint-disable-next-line import/prefer-default-export
export const FILTER_KEYS = {
  PAGE: 'page',
  PER_PAGE: 'limit',
  HAS_MORE: 'hasMore',
  CATEGORIES: 'category',
  MANUFACTURERS: 'manufacturer',
  QUERY: 'query',
  STORAGE: 'storage',
  SORT_DIRECTION: 'orderBy',
};

export const SORT_DIRECTION = {
  // ASC: 'ASC',
  DESC: 'DESC',
  NAME: 'barcodeDescription',
  CATEGORY: 'category',
  MANUFACTURER: 'manufacturer',
};
//
export const TYPE = {
  QUERY: 'query',
};
